// root
export { default as RootView } from './RootView';
export { default as WelcomeView } from './WelcomeView';
// sign in
export { default as SignInView } from './SignInView';
export { default as RecoverPasswordView } from './RecoverPasswordView';
export { default as VerificationView } from './VerificationView';
// profile
export { default as ProfileView } from './ProfileView';
// balance
export { default as BalanceView } from './BalanceView';
export { default as AddFundsView } from './AddFundsView';
export { default as PaymentStateView } from './PaymentStateView';
// reservations
export { default as ReservationsView } from './reservations/ReservationsView';
export { default as ReservationDetailView } from './reservations/ReservationDetailView';
export { default as NewReservationView } from './reservations/NewReservationView';
// dashboard
export { default as DashboardView } from './dashboard/DashboardView';
// admin
export { default as AdminView } from './AdminView';
export { default as UsersView } from './users/UsersView';
// default
export { default as ErrorView } from './ErrorView';
export { default as UnderDevView } from './UnderDevView';
export { default as NotFoundView } from './NotFoundView';



// WEBPACK FOOTER //
// ./src/components/views/index.js